import React from 'preact/compat';
import {h} from 'preact';
import {useEffect, useState} from 'preact/hooks';
import {ConflictDecision} from "./DataLibrary";
import CloseIcon from "./svg/CloseIcon";

export function ConflictSections(props) {
  const [resolved, setResolved] = useState(false);
  const [decision, setDecision] = useState({});

  useEffect(() => {
    setResolved(Object.keys(decision).length === props.conflictSections.length);
  }, [decision]);

  function onChange(section, decision) {
    setDecision(dec => {
      return {
        ...dec,
        [section.id]: decision
      }
    });
  }

  const renderChoice = (section, decision, label) => <div onClick={() => onChange(section, decision)}>
    <input type={'radio'} name={section.name} id={`${section.id}-${decision}`}/>
    <label htmlFor={`${section.id}-${decision}`}>{label}</label>
  </div>;

  return <div className="main light conflicts-main" style="margin-top: 100px;">
    <div className={"conflicts"}>
      {props.conflictSections.map(it =>
        <div key={it.id}>
          <h4>You already have a menu group called: <span>{it.name || 'Group Name'}</span></h4>
          <div className={'choices'}>
            {renderChoice(it, ConflictDecision.Replace, 'Replace')}
            {renderChoice(it, ConflictDecision.Append, 'Append')}
            {renderChoice(it, ConflictDecision.New, 'Create new')}
          </div>
        </div>
      )}
      <footer>
        <button className={'btn primary'} disabled={!resolved} onClick={() => props.onResolved(decision)}>Confirm</button>
      </footer>
    </div>
  </div>
}
